(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.initMap = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/*--------------------------------------------------
W E B S I T E
Website by Websolute
--------------------------------------------------*/
//var $ = jQuery.noConflict();
//var wpInfo = wpToJs;
//console.log(wpInfo);

/*--------------------------------------------------
BIG SLIDER
--------------------------------------------------*/
function catSelect(el) {
  //$('.select-items').click(function () {
  //var cat = $(this).attr('data-cat')
  //var cat = el.value
  alert(el);

  if (cat == 'all') {
    // show all our items
    $('.itemsWrapper').children('section.notebook-listing').addClass('visible').show();
  } else {
    // hide all elements that don't share ourClass
    $('.itemsWrapper').children('section:not(.' + cat + ')').removeClass('visible').hide(); // show all elements that do share ourClass

    $('.itemsWrapper').children('section.' + cat).addClass('visible').show();
  }

  return false; //})
}

function sliderMove() {
  if ($('.slider').length && $('.slider .item').length > 1) {
    //$('.slider').on('init', function (event, slick) {
    //    //$('.slider .slick-slide:eq(0)').removeClass('slick-current');
    //});
    $('.slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      pauseOnHover: false //lazyLoad: 'progressive'

    });
  }
}
/*--------------------------------------------------
SINGLE SLIDER
--------------------------------------------------*/


function sliderSingle() {
  if ($('.slick-wrap').length) {
    $('.slick-wrap').on('init', function (event, slick) {//$('.slider .slick-slide:eq(0)').removeClass('slick-current');
    });
    $('.slick-wrap').slick({
      dots: false,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      pauseOnHover: false
    });
  }
}
/*--------------------------------------------------
SLIDER MULTIPLI ELEMENTI
--------------------------------------------------*/


function sliderMultiple() {
  if ($('.slider-multiple').length) {
    $('.slider-multiple').on('init', function (event, slick) {//$('.slider .slick-slide:eq(0)').addClass('first-animation');
    });
    $('.slider-multiple').slick({
      dots: false,
      arrows: false,
      infinite: false,
      fade: false,
      speed: 500,
      slidesToShow: 4,
      pauseOnHover: false,
      lazyLoad: 'ondemand',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      } // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
      ]
    });
  }
}
/*--------------------------------------------------
IN ANIMATION SCROLL
--------------------------------------------------*/


var observer_, map;

function getObserver() {
  if (observer_) {
    return observer_;
  }

  if ('IntersectionObserver' in window) {
    observer_ = new IntersectionObserver(function (entries, self) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('aos-animate'); //self.unobserve(entry.target);
          // console.log('intersecting');
        } else {
          entry.target.classList.remove('aos-animate');
        }
      });
    });
  } else {
    observer_ = {
      observe: function observe(node) {
        node.classList.add('aos-animate');
      },
      unobserve: function unobserve() {}
    };
  }

  return observer_;
}

_toConsumableArray(document.querySelectorAll('[data-aos="fade-up-custom"]')).map(function (node, id) {
  var observer = getObserver();
  observer.observe(node); // observer.unobserve(node);

  return node;
});

_toConsumableArray(document.querySelectorAll('[data-src]')).map(function (node, id) {
  var observer = new IntersectionObserver(function (entries, self) {
    // iterate over each entry
    entries.forEach(function (entry) {
      // process just the images that are intersecting.
      // isIntersecting is a property exposed by the interface
      if (entry.isIntersecting) {
        // custom function that copies the path to the img
        // from data-src to src
        if (entry.target.dataset.src != '') {
          if (entry.target.tagName != "IMG") {
            preloadImage(entry.target.dataset.src);
            entry.target.style.backgroundImage = "url(" + entry.target.dataset.src + ")";
          } else {
            preloadImage(entry.target.dataset.src);
            entry.target.src = entry.target.dataset.src;
          }
        } // the image is now in place, stop watching


        self.unobserve(entry.target);
      }
    });
  });
  observer.observe(node);
});

function preloadImage(url) {
  var img = new Image();
  img.src = url;
}
/*--------------------------------------------------
INTRO
--------------------------------------------------*/


function intro() {
  var complete = function complete() {
    $('.intro-anim').hide();
  }; // intro animation


  var logo = $('.wrap-logo');
  var overlay = $('.intro-anim');
  gsap.to("#s-bianca", {
    ease: Power2.easeOut,
    x: -130,
    duration: 2,
    delay: 0.7,
    opacity: 1
  });
  gsap.to("#s-bianca path", {
    ease: Power2.easeOut,
    duration: 2,
    fill: "rgb(228,228,228)",
    delay: 1.7
  });
  gsap.to("#s-nera", {
    ease: Power2.easeOut,
    x: 110,
    duration: 2,
    delay: 1,
    opacity: 1
  });
  gsap.to("#full-logo #barra rect, #full-logo #quadrato path", {
    ease: Power2.easeOut,
    opacity: 1,
    duration: 5,
    delay: 2.5
  });
  gsap.to("#letter-e path, #letter-i path", {
    ease: Power2.easeOut,
    opacity: 1,
    duration: 3,
    delay: 3.2
  });
  gsap.to("#letter-h path, #letter-g path", {
    ease: Power2.easeOut,
    opacity: 1,
    duration: 3,
    delay: 3.5
  });
  gsap.to("#letter-t path, #letter-n path", {
    ease: Power2.easeOut,
    opacity: 1,
    duration: 3,
    delay: 3.8
  });
  gsap.to("#letter-e path, #letter-i path", {
    ease: Power2.easeOut,
    opacity: 0,
    duration: 1,
    delay: 6
  });
  gsap.to("#letter-h path, #letter-g path", {
    ease: Power2.easeOut,
    opacity: 0,
    duration: 1,
    delay: 5.9
  });
  gsap.to("#letter-t path, #letter-n path", {
    ease: Power2.easeOut,
    opacity: 0,
    duration: 1,
    delay: 5.8
  });
  gsap.to("#full-logo #barra rect, #full-logo #quadrato path", {
    ease: Power2.easeOut,
    opacity: 0,
    duration: 1.5,
    delay: 6.1
  });
  gsap.to("#s-nera", {
    ease: Power2.easeOut,
    opacity: 0,
    duration: 1.5,
    delay: 6.3
  });
  gsap.to("#s-bianca", {
    ease: Power2.easeOut,
    opacity: 0,
    duration: 0.2,
    delay: 7.8
  });
  gsap.to(overlay, {
    ease: Power2.easeOut,
    opacity: 0,
    duration: 0.4,
    delay: 7.8,
    onComplete: complete
  });
}
/*--------------------------------------------------
Slick scheda
--------------------------------------------------*/


function schedaSlider() {
  $('.scheda-slider').on('init', function (event, slick) {
    $('.scheda-slider .slick-slide').each(function () {
      if ($(window).width() < 768) {
        $(this).find('.caption').css('width', $(this).find('img').width() + 'px').show(); //$(this).find('.caption').show();
      }
    });
  });

  if ($('.scheda-slider').length) {
    $('.scheda-slider').slick({
      infinite: true,
      speed: 500,
      centerMode: true,
      variableWidth: true,
      dots: false,
      arrows: false,
      focusOnSelect: true,
      lazyLoad: 'ondemand' //responsive: [
      //    {
      //        breakpoint: 678,
      //        settings: {
      //            infinite: true,
      //            centerMode: true,
      //            slidesToShow: 1,
      //            slidesToScroll: 1
      //        }
      //    }
      //]

    }).on('init', function (event, slick) {});
  }
}
/*--------------------------------------------------
Nav Main - share
--------------------------------------------------*/


function navMain() {
  $("header").on("click", ".header__burger", function () {
    if ($(this).is('.is-active')) {
      $(this).removeClass('is-active');
      $('body').removeClass('open-nav open-share');
    } else {
      $(this).addClass('is-active');
      $('body').addClass('open-nav');
    }

    return false;
  });
  $('.btn-share').click(function () {
    $('.header__burger').addClass('is-active');
    $('body').addClass('open-share');
    return false;
  });
}
/*--------------------------------------------------
Contact form
--------------------------------------------------*/


function contactForm() {//$("header").on("click", ".header__burger", function () {
  //    if ($(this).is('.is-active')) {
  //        $(this).removeClass('is-active');
  //        $('body').removeClass('open-nav open-share');
  //    } else {
  //        $(this).addClass('is-active');
  //        $('body').addClass('open-nav');
  //    }
  //    return false;
  //});
  //$('[data-form]').click(function () {
  //    $('body').addClass('open-form');
  //    return false;
  //});
}

function tabFilter() {
  $('.tab-listing li a').click(function () {
    // fetch the class of the clicked item
    var ourClass = $(this).attr('class'); // reset the active class on all the buttons

    $('.tab-listing li a').removeClass('active'); // update the active state on our clicked button

    $(this).addClass('active');

    if (ourClass == 'all') {
      // show all our items
      $('.grid-loghi').children('div.item').addClass('visible').show();
    } else {
      // hide all elements that don't share ourClass
      $('.grid-loghi').children('div:not(.' + ourClass + ')').removeClass('visible').hide(); // show all elements that do share ourClass

      $('.grid-loghi').children('div.' + ourClass).addClass('visible').show();
    }

    return false;
  });
}

if ($('.cocoen').length) {
  document.addEventListener('DOMContentLoaded', function () {
    new Cocoen();
  });
}
/*--------------------------------------------------
Custom Select
--------------------------------------------------*/


function customSelect() {
  var x, i, j, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/

  x = document.getElementsByClassName("custom-select");

  for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    /*for each element, create a new DIV that will act as the selected item:*/

    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/

    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");

    for (j = 0; j < selElmnt.length; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.setAttribute("data-cat", selElmnt.options[j].value);
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        var cat = $(this).attr('data-cat');

        if (cat == 'all') {
          // show all our items
          if ($('html').attr('lang') == 'it-IT') {
            //italiano
            window.location.href = "/notebook";
          } else {
            window.location.href = "/en/notebook";
          }

          $('.itemsWrapper').children('section.notebook-listing').addClass('visible').show();
        } else {
          jQuery.ajax({
            contentType: 'text/html',
            data: {
              action: 'getmyCat',
              ck: $(this).attr('data-cat')
            },
            success: function success(result) {
              $('.slider').slick('unslick');
              $('.notebook-hero').html(result);
              $('.slider').slick({
                dots: false,
                arrows: false,
                infinite: true,
                fade: true,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                pauseOnHover: false,
                lazyLoad: 'progressive'
              });
              $('.l-' + $('.single-slide').attr('id')).removeClass('visible').hide();
            },
            type: 'GET',
            url: '/wp-admin/admin-ajax.php'
          }); // hide all elements that don't share ourClass

          $('.itemsWrapper').children('section:not(.' + cat + ')').removeClass('visible').hide(); // show all elements that do share ourClass

          $('.itemsWrapper').children('section.' + cat).addClass('visible').show(); //$('.itemsWrapper').children('section.' + cat + ':first').removeClass('visible').hide();
        }
        /*when an item is clicked, update the original select box,
        and the selected item:*/


        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;

        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");

            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }

            this.setAttribute("class", "same-as-selected ");
            break;
          } //this.setAttribute("data-cat", s.options[i].value);

        }

        h.click();
      });
      b.appendChild(c);
    }

    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x,
        y,
        i,
        arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");

    for (i = 0; i < y.length; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }

    for (i = 0; i < x.length; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/


  document.addEventListener("click", closeAllSelect);

  if (window.location.hash) {
    var hash = window.location.hash.substring(1);
    $(function () {
      if ($('html').attr('lang') == 'it-IT') {
        //italiano
        switch (hash) {
          case 'Work%20In%20Project':
            $('div[data-cat="cat-12"]').click();
            break;

          case 'Events':
            $('div[data-cat="cat-1"]').click();
            break;

          case 'AperiSign':
            $('div[data-cat="cat-11"]').click();
            break;
        }
      } else {
        switch (hash) {
          case 'Work%20In%20Project':
            $('div[data-cat="cat-27"]').click();
            break;

          case 'Events':
            $('div[data-cat="cat-2"]').click();
            break;

          case 'AperiSign':
            $('div[data-cat="cat-28"]').click();
            break;
        }
      }
    });
  }
}
/*--------------------------------------------------
DOC READY
--------------------------------------------------*/


$(function () {
  window.initMap = function () {
    map = new google.maps.Map(document.getElementById('map'), {
      center: new google.maps.LatLng(41.9101002, 12.4910059),
      zoom: 16,
      styles: [{
        "elementType": "geometry",
        "stylers": [{
          "color": "#f5f5f5"
        }]
      }, {
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#616161"
        }]
      }, {
        "elementType": "labels.text.stroke",
        "stylers": [{
          "color": "#f5f5f5"
        }]
      }, {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#bdbdbd"
        }]
      }, {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
          "color": "#eeeeee"
        }]
      }, {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#757575"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{
          "color": "#e5e5e5"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#9e9e9e"
        }]
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [{
          "color": "#ffffff"
        }]
      }, {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#757575"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{
          "color": "#dadada"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#616161"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#9e9e9e"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [{
          "color": "#e5e5e5"
        }]
      }, {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [{
          "color": "#eeeeee"
        }]
      }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
          "color": "#c9c9c9"
        }]
      }, {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#9e9e9e"
        }]
      }]
    });
    var iconBase = '/contrib/themes/TheSignSrl-theme/assets/img/';
    var icons = {
      pin: {
        icon: iconBase + 'pin-custom.png'
      },
      sede: {
        icon: iconBase + 'pin-custom.png'
      }
    };
    var features = [{
      position: new google.maps.LatLng(41.910040, 12.493190),
      type: 'pin'
    }]; // Create markers.

    for (var i = 0; i < features.length; i++) {
      var marker = new google.maps.Marker({
        position: features[i].position,
        icon: icons[features[i].type].icon,
        map: map
      });
    }

    ;
  }; // controllo cookie x intro


  if (document.cookie.indexOf('_intro') === -1) {
    intro();
    var dt = new Date();
    dt.setDate(dt.getDate() + 365);
    document.cookie = '_intro=off; path=/; expires=' + dt.toUTCString();
  } else {
    $('.intro-anim').hide();
  }

  navMain(); //catSelect();

  tabFilter();
  contactForm();
  customSelect();
  var player = new Plyr(document.getElementById('player'));
  $('.fancybox-click').click(function () {
    $('.fancy-brand-name').html($(this).attr('data-brand'));
    $('#field_t2mpm').val($(this).attr('data-brand'));

    if ($(this).attr('data-custom-text') != '') {
      $('.fancy-brand-text').html($(this).attr('data-custom-text'));
    }
  });
  $().fancybox({
    selector: '.scheda-slider .slick-slide:not(.slick-cloned) a'
  });
}); // AL cambio di orientamento device, distruggi e rinizializza masonry

window.addEventListener("orientationchange", function () {
  $('.masonry .grid').masonry('destroy');
  setTimeout(function () {
    $('.masonry .grid').masonry({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.grid-item',
      // use element for option
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true,
      horizontalOrder: true
    });
  }, 2000);
}, false);
/*--------------------------------------------------
WIN LOAD
--------------------------------------------------*/

$(window).on('load', function () {
  sliderMove();
  sliderMultiple();
  schedaSlider();
  sliderSingle();
  /*--------------------------------------------------
  MASONRY
  --------------------------------------------------*/

  $('.masonry .grid').masonry({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: '.grid-item',
    // use element for option
    columnWidth: '.grid-sizer',
    gutter: '.gutter-sizer',
    percentPosition: true,
    horizontalOrder: true
  });
  /*--------------------------------------------------
  FANCYBOX
  --------------------------------------------------*/

  $('[data-fancybox]').fancybox({
    clickOutside: false,
    clickContent: function clickContent(current, event) {
      return false;
    },
    touch: {
      vertical: false // Allow to drag content vertically

    }
  });
  /*--------------------------------------------------
  SMOOTH SCROLL
  --------------------------------------------------*/

  var smoothscroll = Scrollbar.init($('.locomotive')[0], {
    speed: 0.75
  });
  var hash = location.hash;
  console.log('hash', hash);

  if (hash) {
    requestAnimationFrame(function () {
      console.log('scrollTop:', smoothscroll.containerEl.scrollTop);
      smoothscroll.scrollIntoView(document.querySelector(hash), {
        offsetTop: -smoothscroll.containerEl.scrollTop
      });
    });
  } // add addListener smooth scroll


  smoothscroll.addListener(function (status) {
    // menu contratto
    if (smoothscroll.scrollTop > 100) {
      $('body').addClass('menu-fixed');
    } else {
      $('body').removeClass('menu-fixed');
    }

    if (smoothscroll.scrollTop > 200) {
      $('body').addClass('menu-fixed-show');
    } else {
      $('body').removeClass('menu-fixed-show');
    }
  });
  setTimeout(function () {
    if (typeof map == "undefined" && (typeof google === "undefined" ? "undefined" : _typeof(google)) === 'object' && _typeof(google.maps) === 'object') {
      initMap();
    }
  }, 1000);
});
/*--------------------------------------------------
WIN SCROLL
--------------------------------------------------*/

$(window).scroll(function () {//console.log(getScrollTop());
});

},{}]},{},[1])(1)
});
